import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IDevice } from '../../../interfaces/types.ts'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons/faTrashCan'
import { RemoveTracker } from '../RemoveTracker/RemoveTracker.tsx'

interface Props {
    iconOnly?: boolean
    tracker: IDevice
}

export const RemoveTrackerButton: React.FC<Props> = (props) => {
    const {iconOnly, tracker} = props
    const [open, setOpen] = React.useState(false)

    const button = iconOnly ? (
        <div className={'text-secondary text-xl pt-2'} onClick={() => setOpen(true)}>
            <FontAwesomeIcon icon={faTrashCan}/>
        </div>
        ) :
        <button className={'btn btn-xs btn-ghost text-secondary without-ring h-fit'}
                onClick={() => setOpen(true)}>
            Remove Tracker
        </button>

    return (
        <div>
            {button}
            <RemoveTracker tracker={tracker} open={open} setOpen={setOpen}/>
        </div>
    )
}
